import PlayerControls from "./PlayerControls";
import withResponsiveUtils from "../../utils/ResponsiveUtils";

export default withResponsiveUtils(PlayerControls);
